'use client';

import { useSupabaseAuth } from '@/components/auth/SupabaseAuthProvider';
import { syncApiSessionToken } from '@/utils/apiSessionToken';
import { useEffect } from 'react';

/**
 * Syncs the Supabase access token to sessionStorage for the API client.
 * The apiClient interceptor reads this to set the Authorization header.
 * Must be rendered inside SupabaseAuthProvider — routes outside that tree
 * (e.g. /auth/accept-terms) call `syncApiSessionToken` themselves.
 */
export function SessionTokenSync() {
  const { session } = useSupabaseAuth();

  useEffect(() => {
    syncApiSessionToken(session);
  }, [session]);

  return null;
}
